import { Link } from "react-router-dom";

const friendLinks = [
  { label: "电影资料库", to: "/category" },
  { label: "剧集更新日历", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "票房数据", to: "/news" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-bubble-chart-fill text-base" />
              </span>
              <span className="font-heading text-lg font-bold">泡泡影视</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              泡泡影视专注分享最新电影与电视剧资源，并持续提供丰富、专业的影视行业资讯。我们希望成为每一位影视爱好者随手可用的内容入口。
            </p>
            <p className="mt-4 text-sm text-background-300">
              本站为内容演示平台，仅供浏览与资讯阅读，不提供播放与下载服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              快速导航
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  影视分类
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base" />
                <span>hello@bubble-movie.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-base" />
                <span>微信公众号：泡泡影视</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-base" />
                <span>微博：@泡泡影视官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800">
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-background-400 mb-4">
            <span className="text-background-300">友情链接：</span>
            {friendLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-background-400">
            <span>© 2026 泡泡影视 · 内容演示站点，数据仅供展示</span>
            <span>本站影视与资讯均为演示内容，不作商业用途</span>
          </div>
        </div>
      </div>
    </footer>
  );
}